import { defineComponent } from "vue";

/**
 * 渲染 `Hospital` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Hospital = defineComponent({
	name: "Hospital",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M235.6 318.4L98 455.7c20.7 11.5 34.6 33.1 34.6 58.1s-14 46.6-34.6 58.1l137.6 137.3c15.4 15.4 40.4 15.4 55.8 0l128.9-128.6h-141c-8.7 0-15.9-7.2-15.9-15.8V463.3c0-8.6 7.2-15.8 15.9-15.8h141.5L291.4 318.4c-15.4-15.4-40.4-15.4-55.8 0m81.8 472.3L455 928c11.5-20.6 32.7-34.6 58.2-34.6 25 0 46.7 13.9 58.2 34.6L709 790.7c15.4-15.4 15.4-40.3 0-55.7L580.1 606.4v141.1c0 8.6-7.2 15.8-15.9 15.8h-102c-8.7 0-15.9-7.2-15.9-15.8V606.4L317.4 734.5c-15.4 15.4-15.4 40.8 0 56.2m473-81.6L928 571.8c-20.7-11.5-34.6-32.6-34.6-58.1 0-25 14-46.6 34.6-58.1L790.4 318.4c-15.4-15.4-40.4-15.4-55.8 0L605.6 447h141.5c8.7 0 15.9 7.2 15.9 15.8v101.3c0 8.6-7.2 15.8-15.9 15.8H605.6l128.9 128.6c15.5 16 40.5 16 55.9 0.6m-81.8-472.3L571 99.5c-11.5 20.6-32.7 34.6-58.2 34.6-25 0-46.7-13.9-58.2-34.6L317.4 236.8c-15.4 15.4-15.4 40.3 0 55.7l128.9 128.6V280.9c0-8.6 7.2-15.8 15.9-15.8h101.5c8.7 0 15.9 7.2 15.9 15.8V422l128.9-129.1c15.5-15.3 15.5-40.8 0.1-56.1"></path>
			</svg>
		);
	},
});

export default Hospital;
